import { render, staticRenderFns } from "./PcVideoSection.vue?vue&type=template&id=25cd7a97&scoped=true"
import script from "./PcVideoSection.vue?vue&type=script&lang=ts"
export * from "./PcVideoSection.vue?vue&type=script&lang=ts"
import style0 from "./PcVideoSection.vue?vue&type=style&index=0&id=25cd7a97&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cd7a97",
  null
  
)

export default component.exports